class DashboardCartsCreatedController  {
    constructor(createAutoQuery, $session) {
        let options = {
            url: 'QueryCarts.json',
            autoLoad: true
        };
        this.query = createAutoQuery(options);
        this.$session = $session;
    }
    load(){return this.query.load.apply(this.query, arguments);}
}

class DashboardCartsCreated{
    constructor(){
        this.controller = DashboardCartsCreatedController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-carts-created.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardCartsCreated', new DashboardCartsCreated());

export default DashboardCartsCreated